import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Context } from '@nuxt/types'
import { getLocale } from 'app/services/network'
import en from '~/locales/en'
import zh from '~/locales/zh'
import { englishLocale } from '~/locales'

Vue.use(VueI18n)

const fallbackLocale = englishLocale

export default ({ app }: Context) => {
  const locale = getLocale()

  app.i18n = new VueI18n({
    locale: locale ? locale.locale : englishLocale,
    fallbackLocale,
    silentFallbackWarn: true,
    messages: { en, zh }
  })
}
